import React, {Component} from "react"
import {range} from "lodash"
import {Button} from "~/components"

export default class Pagination extends Component {
  renderButton = (page, text) => (
    <Button key={page} onClick={e => this.props.onPageChange(page)}>
      {text}
    </Button>
  )

  render() {
    const currentPage = this.props.currentPage
    const lastPage = this.props.totalPages - 1
    const pageDelta = 2
    const start = Math.max(currentPage - pageDelta, 0)
    const end = Math.min(currentPage + pageDelta, lastPage)

    return (
      this.props.totalPages > 0 && (
        <div className="sh-pagination">
          {currentPage > pageDelta && this.renderButton(0, "«")}

          {range(start, currentPage).map(i => this.renderButton(i, i + 1))}

          <Button disabled>{currentPage + 1}</Button>

          {range(currentPage + 1, end + 1).map(i =>
            this.renderButton(i, i + 1)
          )}

          {currentPage < lastPage - pageDelta &&
            this.renderButton(lastPage, "»")}
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination.js